// Curated palette for Discipline colors (§3.6.1 Discipline Library).
//
// Discipline is a structural signal, not a fit signal — color is purely a UX aid
// so DM / SA / CSM chips are recognisable at a glance in pickers, Pod Position
// cards, and the Shapes matrix. The set is intentionally small and high-contrast
// in both light and dark mode; the library is expected to stay ≤5 entries.
//
// Stored on `discipline.color` as a hex string. Both the API (validation) and the
// UI (swatch picker) read from this single source of truth — never hard-code a hex
// at a call site.

export type DisciplinePaletteColor = {
  name: string;
  hex: string;
};

// Slate is the default; kept as a named constant so DEFAULT_DISCIPLINE_COLOR can
// reference it without indexing into the array (which is `T | undefined` under
// noUncheckedIndexedAccess).
const SLATE: DisciplinePaletteColor = { name: "Slate", hex: "#64748b" };

export const DISCIPLINE_PALETTE: readonly DisciplinePaletteColor[] = [
  SLATE,
  { name: "Indigo", hex: "#6366f1" },
  { name: "Violet", hex: "#8b5cf6" },
  { name: "Sky", hex: "#0ea5e9" },
  { name: "Teal", hex: "#14b8a6" },
  { name: "Emerald", hex: "#10b981" },
  { name: "Amber", hex: "#f59e0b" },
  { name: "Rose", hex: "#f43f5e" },
] as const;

// Default applied to existing/new Disciplines before an admin picks a colour.
export const DEFAULT_DISCIPLINE_COLOR = SLATE.hex;

const PALETTE_HEXES: ReadonlySet<string> = new Set(DISCIPLINE_PALETTE.map((c) => c.hex));

export function isValidDisciplineColor(value: string): boolean {
  return PALETTE_HEXES.has(value);
}
